import React, { Component } from 'react';
import axios from 'axios';
import { BaseUrl } from '../common/config';
import styles from '../common/popup.module.css';

class Changepassword extends Component {

    constructor(props){
        super(props)
        this.state = {
            current_password: '',
            new_password: '',
            confirm_password: '',
            success_message: '',
            popupClose: false,
        }

     } 

    popupClose(){

       var elems = document.getElementsByClassName('change-password-popup');
        for (var i=0;i<elems.length;i+=1){
          elems[i].style.display = 'none';
        }
    }


   OnSubmit = (event) => {
    event.preventDefault();
   
    var authData = JSON.parse(localStorage.getItem('authData'));
    this.setState({ alertPopup:false });
    var loginDetails = {};
    if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
    }           
    let URL = BaseUrl + "changepassword";
    if (this.state.new_password === this.state.confirm_password) {

      let payload = {
        npassword: this.state.current_password,
        cpassword: this.state.confirm_password,
        emailaddress: authData.accountEmail,
       }

      this.setState({ isLoading: true });
      axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {

          if (response.data.success === true) {
            this.setState({success_message: 'You successfully changed your account password!', current_password: '',
                new_password: '',
                confirm_password: '',});
              localStorage.setItem('change_password', '1');
             this.props.close();
             window.location.reload();
          }

        this.setState({ isLoading: false });
      }).catch((error) => {
        if (error !=='' && error.response.status === 400){
        this.setState({ loginMessage: 'The Current Password you have entered is incorrect', isLoading: false, loginStatus:400 });
      }else{

        this.setState({ isLoading: false});
      }
        
      })


    }
    else {
      this.setState({ loginStatus: 401});
      this.setState({ loginMessage: "New Password & Confirm New Password didn't match"});
    }

  }

  handleChange(event){

    if(event.target.name === "current_password"){

       this.setState({ current_password: event.target.value });

    }else if(event.target.name === "new_password"){

        this.setState({ new_password: event.target.value });

    }else if(event.target.name === "confirm_password"){

        this.setState({ confirm_password: event.target.value });
    }

  }

    render() {

       var elems = document.getElementsByClassName('change-password-popup');
            for (var i=0;i<elems.length;i+=1){
              elems[i].style.display = 'block';
            }

        var Changepassword = localStorage.getItem('change_password');

        return(
            <>{this.props.show === 'open' && Changepassword == '' && 
              <div className={`change-password-popup modal ${styles.popupsec} ${this.props.extClass}`} id='change-password-popup'>
                    <div className={styles.popupBlock}>
                        <div className={styles.popupInnr}>
                       <div className='pop-header-top order-top'>    
                            <span className='close' id='popup-close' onClick={this.props.close}>
                            </span>
                            </div>
                            <div className={styles.popupHead}>
                                <h4 className={styles.popupTitle}>Change Password</h4>
                            </div>
                            {(this.state.loginStatus) ? (this.state.loginStatus === 401 ? <p className='err-msg pass-error-msg'>{this.state.loginMessage}</p> : '') : '' }

                            {(this.state.loginStatus) ? (this.state.loginStatus === 400 ? <p className='err-msg pass-error-msg'>{this.state.loginMessage}</p> : '') : '' }

                            <div className={styles.popupBody}>
                            <form onSubmit={this.OnSubmit}>
                            <div className='form-field'>
                                <label htmlFor='name'>Current Password</label>
                                <input type="password" name="current_password" required value={this.state.current_password}  onChange={this.handleChange.bind(this)} />
                            </div>
                            <div className='form-field'>
                                <label htmlFor='accountcode'>New Password</label>
                                <input type="password" name="new_password" required value={this.state.new_password} onChange={this.handleChange.bind(this)}/>
                            </div>
                            <div className='form-field'>
                                <label htmlFor='accountemail'>Confirm New Password</label>
                                <input type="password" name="confirm_password" required value={this.state.confirm_password}  onChange={this.handleChange.bind(this)} />
                            </div>

                            <div className='btn-field'>
                               <button type='submit'>Sumbit</button>
                            </div>
                        </form>

                            </div>
                            <div className={styles.popupFoot}></div>
                        </div>
                    </div>
                    <div className={styles.popupOvly}></div>
                </div>
               }

            </>
        );

    }

}

export default Changepassword;